import { Box, Typography } from "@mui/material";

const ProductsCard = ({
  image,
  text,
  text2,
  marginTopImage,
  marginLeftImage,
  marginTopText2,
  heightColor,
  width,
  height,
  backgroundColor,
  textColor,
  position,
  paddingY,
  paddingX,
  text1Align,
  text2Align,
  isMobile
}) => {
  return (
    <Box
      sx={{
        width: width ? width : 212,
        height: height ? height : 350,
        position: "relative",
        borderRadius: "53px",
        overflow: "hidden",
        boxShadow: 3,
        background: "#F0F0F0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // Centra horizontalmente
      }}
    >
      {/* Imagen centrada */}
      <Box
        component="img"
        src={image}
        alt="imagen"
        sx={{
          maxWidth: "100%", // Ajuste del tamaño para que no se desborde
          maxHeight: "100%", // Limita la altura dentro de la tarjeta
          objectFit: "contain", // Evita que la imagen se recorte
          marginTop: `${marginTopImage}`,
          marginLeft: `${marginLeftImage ? marginLeftImage : null}`,
          zIndex: "10"
        }}
      />

      {/* Caja de texto en la parte inferior */}
      <Box
        sx={{
          position: position ? position : "absolute",
          bottom: 0,
          width: "100%",
          bgcolor: backgroundColor ? backgroundColor : "#1B2466",
          color: textColor ? textColor : "white",
          height: heightColor ? heightColor : "5rem",
          py: paddingY ? paddingY : 2,
          px: paddingX ? paddingX : 2,
          justifyContent: "center", // Centra el texto horizontalmente
          alignItems: "center", // Centra el texto verticalmente
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: textColor ? textColor : "#FFF",
            fontFamily: "Montserrat",
            fontSize: "17px",
            fontWeight: 800,
            letterSpacing: "-0.1px",
            textAlign: text1Align ? text1Align : "center", // Asegura que el texto se mantenga centrado
            lineHeight: "162.5%",
            fontStyle: "normal",
            marginLeft: isMobile ? "2rem" : 0
          }}
        >
          {text}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: textColor ? textColor : "#FFF",
            fontFamily: "Montserrat",
            fontSize: "17px",
            letterSpacing: "-0.1px",
            textAlign: text2Align ? text2Align : "center", // Asegura que el texto se mantenga centrado
            fontStyle: "normal",
            fontWeight: "400",
            marginTop: marginTopText2 ? marginTopText2 : "3.5rem",
            marginLeft: isMobile ? "2rem" : 0
          }}
        >
          {text2}
        </Typography>
      </Box>
    </Box>
  );
};

export default ProductsCard;
